<template lang="pug">
.wrapper.pt-header65(v-if="isSearchEnd")
  header.gheader.-white.gheader-fix
    .gheader__link-back(v-on:click="goList()") 
      a(href="javascript:void(0)") 一覧に戻る
    button.stepup-save-btn.-w110(@click="answerSend(true)")
      span 一時保存
  .container.bg02.txtC.moral-complete(v-if="serviceQuestionAnswer")
    .row.step-up__title-bg(v-bind:style="'text-align: left'")
      h2.moral-complete__sec02__title.fz20.bold.mb10.brown
        | {{ serviceQuestionTitle }}
        br
        | 評価シートの入力
      div
        .bg03.willmust
          .willmust__intro__caution
            p.serviceAnswer-caution-bg
              | 〜{{serviceQuestionAnswer.end_date}}までに
              br
              | 必ず提出してください。
      p.willmust__intro__txt.mt10 ※必ず
        span 全ての項目
        | に回答し、
        .serviceAnswer-caution-color 　最後に
          span.serviceAnswer-caution-color 提出ボタン
          | を押してください。
    .row.step-up__checks
      .col-xs-12.mb10
        input#no_answer(type='checkbox' v-model='isNoAnswer' @click="updateCheckbox(true)")
        label(for="no_answer") 今月は提出しない
        div(v-if="isNoAnswer")
          .row
            .col-xs-12.mb10
              label 理由 
                span.text-danger *
              select.form-control(v-model="serviceQuestionAnswer.no_answer_reason")
                option(value="") 理由を選択してください
                option(value="出勤が極端に少ない") 出勤が極端に少ない
                option(value="退職予定（当月または翌月）") 退職予定（当月または翌月）
                option(value="勤番が異なっていた") 勤番が異なっていた
                option(value="ホールで見かけていない") ホールで見かけていない
                option(value="その他") その他
            .col-xs-12.mb10(v-if="serviceQuestionAnswer.no_answer_reason === 'その他'")
              label その他の場合は理由を入力。
              textarea.form-control(v-model="serviceQuestionAnswer.no_answer_reason_other" rows=5 maxlength="1000")
      .col-xs-6.mb20
        input#part_answer(type='checkbox' v-model='isPartAnswer' @click="updateCheckbox(false)")
        label(for="part_answer") カウンターのみで評価
        div(v-if="isPartAnswer")
          .row
            .col-xs-12.mb10
              label 理由 
                span.text-danger *
              select.form-control(v-model="serviceQuestionAnswer.part_answer_reason")
                option(value="") 理由を選択してください
                option(value="ホール業務の日が少ない") ホール業務の日が少ない
                option(value="年齢制限による配置（20歳未満）") 年齢制限による配置（20歳未満）
                option(value="怪我・病気の治療中") 怪我・病気の治療中
                option(value="妊娠中の業務配慮") 妊娠中の業務配慮
                option(value="その他") その他
            .col-xs-12.mb10(v-if="serviceQuestionAnswer.part_answer_reason === 'その他'")
              label その他の場合は理由を入力。
              textarea.form-control(v-model="serviceQuestionAnswer.part_answer_reason_other" rows=5 maxlength="1000")
    .row.serviceAnswer-caution__sec.serviceAnswer-answer-bg
      .user-outline
        .user-outline__img(v-if="serviceQuestionAnswer.profile_image")
          img(v-bind:src="serviceQuestionAnswer.profile_image_path + '?token=' + authToken + '&timestamp=' + timeStamp")
        .user-outline__img(v-else)
          img(src='./images/img_profile.png', alt='')
        .brown.home__step-up__content-member-text-item
          span.fz19.brown {{serviceQuestionAnswer.service_question_answer_user_name}}
          | さんの
          br
          | {{serviceQuestionAnswer.is_own ? '自己' : ''}}評価をお願いいたします。
    template(v-if="serviceAnswerDetails.length && !isNoAnswer")
      div.mb20(v-for="(serviceAnswerDetail, index) in serviceAnswerDetails")
        template(v-if="isPartAnswer && serviceAnswerDetail.attributes['category'] == '所作'")
        tempalte(v-else)
          .row.evaluate-answer-title.text-left(v-if="index == 0 || serviceAnswerDetail.attributes['category-id'] != serviceAnswerDetails[index - 1].attributes['category-id']")
            p {{ serviceAnswerDetail.attributes['category'] }}
            span.mt10.service-question-description 1：達成率50％未満
            span.service-question-description 2：達成率50％以上80％未満
            span.service-question-description 3：達成率80％以上
          div.text-left.mt10
            p.scene {{ serviceAnswerDetail.attributes['scene'] }}
          div.text-left.mt5
            p {{ serviceAnswerDetail.attributes['content'] }}
          div.mb30
            .row
              .col-xs-1
              .col-xs-10
                service-answer-edit-slider(:serviceAnswerDetail="serviceAnswerDetail",:index="index", @handleMouseDown="handleMouseDown", @handleChange="handleChange")
              .col-xs-1
    div(v-if="!serviceQuestionAnswer.is_own")
      .row.evaluate-answer-title.text-left
        p 評価メモ
        label 評価時のメモとしてご利用ください。他者に共有されることはありません。
      .row
        textarea.form-control(v-model="serviceQuestionAnswer.memo" rows=5 maxlength="1000")
    .row.step-up__title-bg
      p.step-up__title-text.mb10
        template(v-if="canSave")
          span.bold {{serviceQuestionAnswer.service_question_answer_user_name}}さん
          | の{{serviceQuestionAnswer.is_own ? '自己' : ''}}評価は
          br
          | 以上でよろしいですか？
        span(v-else) ※この評価は{{serviceQuestionAnswer.start_date}}以降提出できます。
      button.btn01.-home-style(v-if="isAllAnswer && canSave", @click="openSendConfirmModal(false)")
        span 提出する
      button.btn01.-unavailable.-home-style(v-else)
        span(style="background: none;") 提出する

    // モーダル表示用
    button#serviceAnswerSendConfirmModalButton.hide(type="button", data-backdrop="static", data-toggle="modal" data-target="#serviceAnswerSendConfirmModal") モーダル発火用
    #serviceAnswerSendConfirmModal.help-modal
      .help-modal__body.servie-send__modal(style="margin-top: 200px;")
        p.brown.bold.mb25(v-if="serviceQuestionAnswer.is_own") 自己評価を提出してよろしいでしょうか？
        p.brown.bold.mb25 {{serviceQuestionAnswer.service_question_answer_user_name}}さんの評価を提出してよろしいでしょうか？
        .mb20
          a.btn-link(data-dismiss="modal", href="javascript:void(0)") キャンセル
        button.btn02.moral-going__modal-btn(type="button", data-dismiss="modal", style="width: 214px;", v-if="isAllAnswer", @click="answerSend(false)")
          span 提出する
          
    // モーダル表示用
    button#serviceAnswerSendModalButton.hide(type="button", data-backdrop="static", data-toggle="modal" data-target="#serviceAnswerSendModal") モーダル発火用
    #serviceAnswerSendModal.help-modal
      .help-modal__body.stepup-send__modal(style="margin-top: 200px;")
        p.brown.bold.mb25 提出しました。
        button.btn02.moral-going__modal-btn(type="button", data-dismiss="modal", v-on:click="goList()" style="width: 214px;")
          span 一覧へ

    // モーダル表示用
    button#serviceAnswerTempSaveModalButton.hide(type="button", data-backdrop="static", data-toggle="modal" data-target="#serviceAnswerTempSaveModal") モーダル発火用
    #serviceAnswerTempSaveModal.help-modal
      .help-modal__body.stepup-send__modal(style="margin-top: 200px;")
        p.brown.bold.mb25 保存しました。
        button.btn02.moral-going__modal-btn(type="button", data-dismiss="modal", style="width: 214px;")
          span 閉じる

</template>
<script>
import ServiceAnswerEditSlider from './ServiceAnswerEditSlider'
import dayjs from 'dayjs'
export default {
  name: 'service-answer-edit',
  created () {
    this.search()
  },
  components: {
    ServiceAnswerEditSlider
  },
  data () {
    return {
      isSearchEnd: false,
      serviceQuestionTitle: '',
      serviceQuestionAnswer: {},
      serviceAnswerDetails: [],
      isNoAnswer: false,
      isPartAnswer: false
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    isAllAnswer () {
      let isAllAnswer = true
      if (this.isNoAnswer) {
        // 「今月は提出しない」場合はno_answer_reasonが必須
        if (!this.serviceQuestionAnswer.no_answer_reason) {
          return false
        }
        // 「その他」の場合はno_answer_reason_otherも必須
        if (this.serviceQuestionAnswer.no_answer_reason === 'その他' && !this.serviceQuestionAnswer.no_answer_reason_other) {
          return false
        }
        return true
      }
      if (this.isPartAnswer) {
        // 「カウンターのみで評価」場合はpart_answer_reasonが必須
        if (!this.serviceQuestionAnswer.part_answer_reason) {
          return false
        }
        // 「その他」の場合はpart_answer_reason_otherも必須
        if (this.serviceQuestionAnswer.part_answer_reason === 'その他' && !this.serviceQuestionAnswer.part_answer_reason_other) {
          return false
        }
      }
      this.serviceAnswerDetails.map(serviceAnswerDetail => {
        if (isAllAnswer && (serviceAnswerDetail.point === undefined || serviceAnswerDetail.point === '未回答')) {
          if (serviceAnswerDetail.attributes['category'] === '所作' && this.isPartAnswer) {
            isAllAnswer = true
          } else {
            isAllAnswer = false
          }
        }
      })
      return isAllAnswer
    },
    canSave () {
      return this.serviceQuestionAnswer['answer_start_date'] && dayjs(this.serviceQuestionAnswer['answer_start_date']) <= dayjs()
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      const data = {id: this.$route.params.id}
      let res = await this.$store.dispatch('SERVICE_ANSWER_DETAIL_LIST', {data: data})
      .catch(err => {
        console.log(err)
        return
      })
      this.serviceQuestionTitle = res.service_question_title
      this.serviceQuestionAnswer = res.service_question_answer
      this.serviceAnswerDetails = res.service_question_answer_details.data.map(serviceQuestionAnswerDetail => {
        serviceQuestionAnswerDetail['point'] = serviceQuestionAnswerDetail.attributes['point'] || undefined
        serviceQuestionAnswerDetail['isFirstClick'] = true
        return serviceQuestionAnswerDetail
      })
      // チェックボックスの状態を初期化
      this.isNoAnswer = this.serviceQuestionAnswer.is_no_answer || false
      this.isPartAnswer = this.serviceQuestionAnswer.is_part_answer || false

      // no_answer_reasonの初期化処理
      if (this.serviceQuestionAnswer.no_answer_reason) {
        const predefinedReasons = ['出勤が極端に少ない', '退職予定（当月または翌月）', '勤番が異なっていた', 'ホールで見かけていない']
        if (predefinedReasons.includes(this.serviceQuestionAnswer.no_answer_reason)) {
          // 定型理由の場合はそのまま設定
          this.serviceQuestionAnswer.no_answer_reason = this.serviceQuestionAnswer.no_answer_reason
        } else {
          // その他の理由の場合は「その他」を選択し、テキストエリアに内容を設定
          this.serviceQuestionAnswer.no_answer_reason_other = this.serviceQuestionAnswer.no_answer_reason
          this.serviceQuestionAnswer.no_answer_reason = 'その他'
        }
      }

      // part_answer_reasonの初期化処理
      if (this.serviceQuestionAnswer.part_answer_reason) {
        const predefinedPartReasons = ['ホール業務の日が少ない', '年齢制限による配置（20歳未満）', '怪我・病気の治療中', '妊娠中の業務配慮']
        if (predefinedPartReasons.includes(this.serviceQuestionAnswer.part_answer_reason)) {
          // 定型理由の場合はそのまま設定
          this.serviceQuestionAnswer.part_answer_reason = this.serviceQuestionAnswer.part_answer_reason
        } else {
          // その他の理由の場合は「その他」を選択し、テキストエリアに内容を設定
          this.serviceQuestionAnswer.part_answer_reason_other = this.serviceQuestionAnswer.part_answer_reason
          this.serviceQuestionAnswer.part_answer_reason = 'その他'
        }
      }

      this.isSearchEnd = true
    },
    openModal: function (serviceQuestionAnswerId) {
      this.selectedServiceQuestionAnswerId = serviceQuestionAnswerId
      var button = document.getElementById('serviceAnserEditModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goserviceAnswerList: function () {
      this.$router.push({ path: '/service_ansers' })
    },
    goList: function () {
      this.$router.push({ path: '/service_answers' })
    },
    serviceSendModal: function (mode) {
      let modal = ''
      if (mode === 'send') {
        modal = 'serviceAnswerSendModalButton'
      } else {
        modal = 'serviceAnswerTempSaveModalButton'
      }
      const button = document.getElementById(modal)
      button.click() // モーダル表示 イベント発火
    },
    openSendConfirmModal: function (mode) {
      let modal = 'serviceAnswerSendConfirmModalButton'
      const button = document.getElementById(modal)
      button.click() // モーダル表示 イベント発火
    },
    answerSend: async function (isTemporarilySaved = false) {
      const serviceAnswerId = this.$route.params.id
      const data = {
        service_question_answer_id: serviceAnswerId,
        is_temporarily_saved: isTemporarilySaved,
        no_answer_reason: this.serviceQuestionAnswer.no_answer_reason === 'その他' ? this.serviceQuestionAnswer.no_answer_reason_other : this.serviceQuestionAnswer.no_answer_reason,
        part_answer_reason: this.serviceQuestionAnswer.part_answer_reason === 'その他' ? this.serviceQuestionAnswer.part_answer_reason_other : this.serviceQuestionAnswer.part_answer_reason,
        is_no_answer: this.isNoAnswer,
        is_part_answer: this.isPartAnswer,
        memo: this.serviceQuestionAnswer.memo,
        service_question_answer_details: this.serviceAnswerDetails.filter(serviceAnswerDetail => serviceAnswerDetail.point !== undefined).map(serviceAnswerDetail => {
          if (this.isNoAnswer || (this.isPartAnswer && serviceAnswerDetail.attributes['category'] === '所作')) {
            return {id: serviceAnswerDetail.id, point: undefined}
          } else {
            return {id: serviceAnswerDetail.id, point: serviceAnswerDetail.point}
          }
        })
      }
      await this.$store.dispatch('SERVICE_ANSWER_ANSWER_UPDATE', {data: data})
      .catch(err => {
        console.log(err)
        return
      })
      this.serviceSendModal(isTemporarilySaved ? 'temp' : 'send')
    },
    data: function (maxPoint) {
      return [...Array(maxPoint)].map((_, i) => i + 1)
    },
    handleMouseDown: function (newValue, index) {
      console.log('newValue')
      console.log(newValue)
      console.log('index')
      console.log(newValue)
      if (this.serviceAnswerDetails[index].isFirstClick) {
        this.serviceAnswerDetails[index].point = newValue
        this.serviceAnswerDetails[index].isFirstClick = false
      }
    },
    handleChange: function (value, index) {
      if (!this.serviceAnswerDetails[index].isFirstClick) {
        this.serviceAnswerDetails[index].point = value
      }
    },
    updateCheckbox: function (isNoAnswer) {
      if (isNoAnswer && !this.isNoAnswer) {
        this.isPartAnswer = false
      } else if (!isNoAnswer && !this.isPartAnswer) {
        this.isNoAnswer = false
      }
    }
  }
}
</script>
<style>
.step-up__checks {
  background: #F7F4EA;
  text-align: left;
}
.no-answer {
  background: #F7F4EA;
}
.service-question-description {
  font-weight: normal;
  font-size: 11px!important;
  padding: 0 8px 0 0;
}
.scene {
  color: #3E200C;
  font-weight: bold;
}
.servie-send__modal {
  background: #FFFCFA;
  height: 200px;
}
</style>


// WEBPACK FOOTER //
// ServiceAnswerEdit.vue?3e46bec2